import * as React from 'react';
import { Section } from '../Section';
import * as styles from './Aside.css';

export interface IAsideProps {
  banner: React.ReactNode;
  builderInfo: React.ReactNode;
  termsInfo: React.ReactNode;
}

export const Aside: React.VFC<IAsideProps> = ({ banner, builderInfo, termsInfo }) => {
  return (
    <aside className={styles['aside']} data-testid="Aside">
      <div className={styles['aside_container']}>
        <Section padding={false}>
          {termsInfo}
          {builderInfo}
        </Section>
        <div className={styles['banner']}>{banner}</div>
      </div>
    </aside>
  );
};
